export function renderField(property: string, value: any) {
  if (value) {
    return `${property}: ${value}`
  }
  return '';
}

export function renderStringField(property: string, value: any) {
  if (value) {
    return `${property}: "${value}"`
  }
  return '';
}

export function trimQuery(query: string): string {
  return removeNewLines(removeComments(removeIndentation(query)));
}

function removeIndentation(query: string): string {
  return query.replace(/^\s*/gm, "");
}

function removeComments(query: string): string {
  return query.replace(/^#.*$/gm, "");
}

function removeNewLines(query: string): string {
  return query.replace(/\n/gm, " ");
}
